import React, { useState, useRef, useEffect } from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import {
  create_product_category,
  edit_product_category
} from '@app/pages/product-categories/redux/reducer';
import { useDispatch, useSelector } from 'react-redux';
import { getCategoryLoading } from '@app/pages/product-categories/redux/selectors';
import { Input, Modal, TextArea } from '@app/pages/meals/components/addIngredients';
import { ImSpinner } from 'react-icons/im';

const enums_marketplace = [
  {
    title: 'Yes',
    value: true
  },
  {
    title: 'No',
    value: false
  }
];

const AddCategory = ({ onClose, isOpen, isEdit, category }) => {
  const [image, setProductImage] = useState(null);
  const dispatch = useDispatch();
  const loading = useSelector(getCategoryLoading);
  const [selected, setSelected] = useState(category?.on_marketplace || false);

  useEffect(() => {
    if (category?.on_marketplace) {
      setSelected(category?.on_marketplace);
    }
  }, [category]);

  useEffect(() => {
    if (category?.image) {
      setProductImage(category?.image);
    }
  }, [category]);

  let initialValues = {
    name: category?.name || '',
    description: category?.description || ''
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string().min(3).required().label('Name'),
    description: Yup.string().min(3).required().label('Description')
  });

  const handleClose = () => {
    setProductImage(null);
    onClose();
  };

  const onSubmit = async (doc) => {
    const cleanedDoc = Object.fromEntries(
      Object.entries(doc).filter(([_, value]) => value !== '')
    );

    let payload = {
      ...cleanedDoc
    };

    if (image !== '' && image !== null && image !== undefined) {
      payload.image = image;
    }

    if (isEdit) {
      let data = {
        ...payload,
        on_marketplace: selected
      };
      return dispatch(
        edit_product_category({ data, onClose: handleClose, id: category?._id })
      );
    } else {
      dispatch(create_product_category({ data: payload, onClose: handleClose }));
    }
  };

  const imgRef = useRef();

  const handleOpenImage = () => {
    imgRef.current.click();
  };

  const handlePickImage = (e) => {
    setProductImage(e.target.files[0]);
  };
  return (
    <Modal
      title={isEdit ? 'Edit Category' : 'Create Category'}
      isOpen={isOpen}
      onClose={handleClose}
      onClick={(e) => e.StopPropagation()}
    >
      <div>
        <Formik
          initialValues={initialValues}
          validateOnChange={true}
          validationSchema={validationSchema}
          onSubmit={(values) => {
            onSubmit(values);
          }}
        >
          {({ values, handleChange, errors, touched, handleBlur, handleSubmit }) => (
            <Form className="flex flex-col gap-4">
              <div className="flex flex-col gap-1">
                <label
                  className="text-[#14151A] text-[14px] font-medium"
                  htmlFor="name"
                >
                  Category Name
                </label>
                <Input
                  name={'name'}
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  value={values.name}
                  placeholder={'Category Name'}
                />
                {touched.name && errors.name && (
                  <p className="mt-1 text-red-500 text-[12px]">{errors.name}</p>
                )}
              </div>

              <div className="flex flex-col gap-1">
                <label
                  className="text-[#14151A] text-[14px] font-medium"
                  htmlFor="description"
                >
                  Description
                </label>
                <TextArea
                  name={'description'}
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  value={values.description}
                  placeholder={'Description'}
                />
                {touched.description && errors.description && (
                  <p className="mt-1 text-red-500 text-[12px]">
                    {errors.description}
                  </p>
                )}
              </div>

              {isEdit && (
                <div>
                  <label
                    className="text-[#14151A] text-[14px] font-medium"
                    htmlFor="description"
                  >
                    On Marketplace
                  </label>
                  <div className="flex gap-4">
                    {enums_marketplace.map((item, index) => (
                      <div
                        key={index}
                        className="flex gap-2 items-center cursor-pointer"
                      >
                        <input
                          type="radio"
                          name="on_marketplace"
                          value={item.value}
                          checked={selected === item.value}
                          onChange={() => setSelected(item.value)}
                          className="accent-[#549A9A]"
                        />
                        <span>{item.title}</span>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              <div>
                <input
                  type="file"
                  accept=".jpg, .png, .jpeg"
                  onChange={handlePickImage}
                  ref={imgRef}
                  className="hidden"
                />
                <label>Choose Image</label>

                {image !== null ? (
                  <div>
                    <img
                      src={
                        typeof image === 'string'
                          ? image
                          : URL.createObjectURL(image)
                      }
                      alt={'shared'}
                      className="w-full h-[300px] object-contain"
                      onClick={handleOpenImage}
                    />
                  </div>
                ) : (
                  <div
                    className="cursor-pointer border border-dashed grid place-items-center h-[300px] rounded-md"
                    onClick={handleOpenImage}
                  >
                    <div className="text-gray-600">Choose File</div>
                  </div>
                )}

                {image !== null && (
                  <div
                    onClick={() => setProductImage(null)}
                    className="mt-2 text-red-500 cursor-pointer"
                  >
                    Remove Image
                  </div>
                )}
              </div>

              <div>
                <button
                  type="button"
                  className="grid place-items-center bg-[#549A9A] h-[40px] rounded-md text-[14px] text-[#E2FFEE] font-semibold"
                  onClick={handleSubmit}
                  style={{ width: '100%' }}
                >
                  {loading ? <ImSpinner className="animate-spin" /> : 'Submit'}
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </Modal>
  );
};

export default AddCategory;
